import React from 'react';
import { BaseView } from '../../views/baseView';
import * as Styles from '../_shared/Styles';

type Props = {};

export const BasePage = (_props: Props) => {
	return (
		<Styles.PageWrapper>
			<BaseView />
		</Styles.PageWrapper>
	);
};
